// src/pages/Event.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import backgroundImage from "../assets/About2.jpg";
// style={{
//         background: `linear-gradient(rgba(3, 7, 18, 0.65), rgba(3, 7, 18, 0.65)), url(${backgroundImage})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}


const tabs = [
  { key: "upcoming", label: "Upcoming Events" },
  { key: "completed", label: "Completed Events" },
];

const sampleUpcoming = [
  {
    title: "Sales Excellence Bootcamp",
    date: " ",
    location: "Navi Mumbai",
    blurb:
      "High-impact, practical sales strategies for B2B construction markets.",
    accent: "from-fuchsia-500 to-pink-500",
    ctaText: "View Details",
    ctaHref: "/event/upcoming",
  },
  {
    title: "Leadership & Team Dynamics",
    date: " ",
    location: "Pune",
    blurb:
      "Lead with clarity: communication, conflict resolution, and performance.",
    accent: "from-sky-500 to-cyan-500",
    ctaText: "View Details",
    ctaHref: "/event/upcoming",
  },
];

const sampleCompleted = [
  {
    title: "Digital Marketing for Builders",
    date: " ",
    location: "Mumbai",
    blurb: "SEO, SEM, and social media tactics tailored for construction.",
    accent: "from-emerald-500 to-lime-500",
    ctaText: "View Gallery",
    ctaHref: "/event/completedevent",
  },
  {
    title: "Project Safety & Quality",
    date: " ",
    location: "Thane",
    blurb: "Best practices in site safety and QA/QC for project success.",
    accent: "from-amber-500 to-orange-500",
    ctaText: "View Gallery",
    ctaHref: "/event/completedevent",
  },
];

const EventCard = ({ item }) => {
  return (
    <div className="group relative rounded-2xl p-[2px] transition-transform duration-300 hover:-translate-y-0.5">
      {/* Gradient border */}
      <div
        className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${item.accent} opacity-90 blur-[2px]`}
      />
      <div className="relative z-10 h-full rounded-2xl bg-white/90 p-6 shadow-xl ring-1 ring-black/5 backdrop-blur">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              {item.title}
            </h3>
            <p className="mt-1 text-sm text-gray-600">
              {item.date} • {item.location}
            </p>
          </div>
          <div
            className={`rounded-xl bg-gradient-to-br ${item.accent} p-2 text-white shadow`}
          >
            {/* Calendar Icon */}
            <svg
              viewBox="0 0 24 24"
              className="h-5 w-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path d="M7 3v3M17 3v3M4.5 9h15M6 6h12a1.5 1.5 0 0 1 1.5 1.5v10A1.5 1.5 0 0 1 18 19H6a1.5 1.5 0 0 1-1.5-1.5v-10A1.5 1.5 0 0 1 6 6z" />
            </svg>
          </div>
        </div>

        <p className="mt-3 text-sm text-gray-700">{item.blurb}</p>

        <div className="mt-5 flex items-center justify-between">
          <div className="h-1 flex-1 rounded-full bg-gradient-to-r from-gray-100 via-gray-50 to-gray-100" />
          <a
            href={item.ctaHref}
            className={`ml-4 inline-flex items-center justify-center rounded-xl bg-gradient-to-r ${item.accent} px-4 py-2 text-xs font-semibold text-white shadow-md transition hover:scale-[1.02]`}
          >
            {item.ctaText}
          </a>
        </div>
      </div>
      {/* Glow on hover */}
      <div
        className={`pointer-events-none absolute -inset-2 -z-10 rounded-3xl opacity-0 transition duration-300 group-hover:opacity-100 bg-gradient-to-br ${item.accent} blur-2xl`}
      />
    </div>
  );
};

const Event = ({ selectedTab: defaultTab = "upcoming" }) => {
  const [selectedTab, setSelectedTab] = useState(defaultTab);
  const navigate = useNavigate();

  useEffect(() => {
    setSelectedTab(defaultTab);
  }, [defaultTab]);

  const onTabChange = (tabKey) => {
    setSelectedTab(tabKey);
    if (tabKey === "completed") {
      navigate("/event/completedevent");
    } else {
      navigate("/event/upcoming");
    }
  };

  const isUpcoming = selectedTab === "upcoming";
  const list = isUpcoming ? sampleUpcoming : sampleCompleted;

  return (
    <section className="relative overflow-hidden">
      {/* Multicolor animated background */}
      <div className="pointer-events-none absolute inset-0 -z-20">
        <div className="absolute inset-0 bg-[radial-gradient(80%_60%_at_20%_10%,rgba(255,0,128,0.18),transparent_60%),radial-gradient(70%_50%_at_80%_0%,rgba(56,189,248,0.18),transparent_60%),radial-gradient(60%_60%_at_50%_100%,rgba(250,204,21,0.18),transparent_60%)]" />
        <div className="absolute -inset-40 animate-pulse-slow rounded-full bg-gradient-to-br from-fuchsia-400/40 via-cyan-300/30 to-amber-300/30 blur-3xl" />
      </div>
      {/* Soft white overlay */}
      <div className="absolute inset-0 -z-10 bg-gradient-to-b from-white/70 via-white/60 to-white/80 " />

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 mb-[2rem]">
        {/* Header */}
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/80 px-3 py-1 text-xs font-semibold text-gray-700 ring-1 ring-black/5 backdrop-blur">
            <span className="inline-block h-2 w-2 animate-ping rounded-full bg-emerald-500" />
            Explore GrowMax-OGCS Events
          </span>
          <h1 className="mt-4 bg-gradient-to-r from-fuchsia-600 via-sky-600 to-amber-600 bg-clip-text text-3xl font-extrabold tracking-tight text-transparent sm:text-5xl">
            Learn • Lead • Grow
          </h1>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-gray-600 sm:text-base">
            From sales to leadership and safety—each session is designed to
            drive real outcomes in the construction ecosystem.
          </p>
        </div>

        {/* Tabs */}
        <div className="mx-auto mt-10 w-full max-w-xl">
          <div className="relative rounded-2xl bg-white/80 p-1 shadow-xl ring-1 ring-black/5 backdrop-blur">
            <div
              className="grid grid-cols-2 gap-1 py-[2px]"
              role="tablist"
              aria-label="Tabs"
            >
              {tabs.map((tab) => {
                const active = selectedTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={active}
                    aria-controls={`panel-${tab.key}`}
                    onClick={() => onTabChange(tab.key)}
                    className={[
                      "relative isolate overflow-hidden rounded-xl px-4 py-2 text-sm font-semibold",
                      "transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-fuchsia-500/60",
                      active
                        ? "text-white shadow-md"
                        : "text-gray-700 hover:text-gray-900",
                    ].join(" ")}
                  >
                    {/* Active gradient background */}
                    <span
                      aria-hidden="true"
                      className={[
                        "absolute inset-0 z-0 rounded-xl transition-opacity duration-200",
                        active
                          ? tab.key === "upcoming"
                            ? "opacity-100 bg-gradient-to-r from-fuchsia-600 via-rose-500 to-orange-500"
                            : "opacity-100 bg-gradient-to-r from-emerald-500 to-lime-500"
                          : "opacity-0",
                      ].join(" ")}
                    />
                    <span className="relative z-10">{tab.label}</span>
                  </button>
                );
              })}
            </div>

            {/* Underline indicator */}
            <div
              className={[
                "pointer-events-none absolute bottom-0 left-0 h-1 w-1/2 rounded-b-xl bg-gradient-to-r transition-all duration-300",
                selectedTab === "upcoming"
                  ? "from-fuchsia-500 via-rose-500 to-orange-500 translate-x-0"
                  : "from-emerald-500 to-lime-500 translate-x-full",
              ].join(" ")}
            />
          </div>
        </div>

        {/* Content */}
        <div className="mt-[4rem] grid gap-6 sm:grid-cols-2 ">
          {list.map((item) => (
            <EventCard key={item.title} item={item} />
          ))}

          {/* Big CTA Card */}
          <div className="group relative rounded-2xl p-[2px] mt-4 sm:col-span-2 lg:col-span-3 transition-transform duration-300 hover:-translate-y-0.5">
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-sky-500 via-fuchsia-500 to-amber-500 opacity-90 blur-[2px]" />
            <div className="relative z-10 rounded-2xl bg-white/90 p-8  shadow-xl ring-1 ring-black/5 backdrop-blur">
              <div className="flex flex-col items-center justify-between gap-4 text-center sm:flex-row sm:text-left">
                <div>
                  <h3 className="text-xl font-bold text-gray-900">
                    Want a custom training for your team?
                  </h3>
                  <p className="mt-1 text-sm text-gray-700">
                    We design programs tailored to your project goals and
                    timelines.
                  </p>
                </div>
                <div className="flex flex-wrap items-center gap-3">
                  <a
                    href="mailto:growmax@ogcs.co.in?subject=Custom%20Training%20Enquiry"
                    className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-fuchsia-600 via-rose-500 to-orange-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-rose-500/20 transition hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-rose-400 focus:ring-offset-2"
                  >
                    Email Us
                  </a>
                  <a
                    href="tel:+919967621235"
                    className="inline-flex items-center justify-center rounded-xl bg-gradient-to-r from-sky-600 to-cyan-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-sky-500/20 transition hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-offset-2"
                  >
                    Call Now
                  </a>
                </div>
              </div>
            </div>
            <div className="pointer-events-none absolute -inset-2 -z-10 rounded-3xl opacity-0 transition duration-300 group-hover:opacity-100 bg-gradient-to-r from-sky-500 via-fuchsia-500 to-amber-500 blur-2xl" />
          </div>
        </div>
      </div>

      {/* Local keyframes for soft animated glow */}
      <style>
        {`
          @keyframes pulse-slow {
            0%, 100% { transform: scale(1); opacity: 0.7; }
            50% { transform: scale(1.06); opacity: 1; }
          }
          .animate-pulse-slow {
            animation: pulse-slow 8s ease-in-out infinite;
          }
        `}
      </style>
    </section>
  );
};

export default Event;
